// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThreeImageRevolution_wrapper__zemsT"};